import { TweenMax, TimelineMax, Circ } from 'gsap/TweenMax';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Masonry from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';
import Isotope from 'isotope-layout';
import Flickity from 'flickity';
import Player from '@vimeo/player';
import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import { throttle } from 'lodash';

const QUOLUX = {};
window.QUOLUX = QUOLUX;
(() => {
  let winSize = 0;
  const SCREENMDMAX = 1199;
  const SCREEN_SM_MAX = 767;
  const scrollTo = (elt, duration, target) => {
    console.log('scrollto', elt, duration, target);
    TweenMax.to(
      window, duration || 1,
      {
        scrollTo: elt.getBoundingClientRect().top + window.scrollY,
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  const scrollToId = (href) => {
    if (href !== undefined) {
      const target = href.split('#')[1];
      if (document.getElementById(target) !== null) {
        scrollTo(document.getElementById(target), 1, target);
      }
    }
  };

  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  calcWinSize();

  class AccordionMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        TweenMax.to(this.DOM.content, 0.2, { height: 'auto' });
        if (this.DOM.btn) {
          scrollTo(this.DOM.btn, 0.6);
        }
        this.DOM.elt.classList.add('is-active');
      } else {
        TweenMax.to(this.DOM.content, 0.2, { height: 0 });
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }

  class AccordionMenu {
    constructor(elt) {
      this.DOM = { elt };
      this.settings = this.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(this.DOM.elt.getAttribute('data-accordion')) : {};
      this.menuItems = [];
      Array.from(this.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => this.menuItems.push(new AccordionMenuItem(item)));
      this.init();
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (this.current !== pos && this.menuItems[this.current].isOpen) {
        this.menuItems[this.current].hide();
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }

  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);
        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }
        flck.on('change', (index) => {
          console.log('changed', index);
          if (typeof QUOLUX.vimeos !== 'undefined' && QUOLUX.vimeos.length > 0) {
            QUOLUX.vimeos.forEach((elt) => {
              elt.pause();
            });
          }
          self.flcks.forEach((f) => {
            console.log('flk', f);
            f.select(index);
          });
        });
        self.flcks.push(flck);
        idx += 1;
      });
    }
  }

  class MainNav {
    constructor() {
      if (document.querySelector('.main-nav-wrapper')) {
        const self = this;
        self.DOM = { elt: document.querySelector('.main-nav-wrapper') };
        self.DOM.openBtn = document.querySelector('.burger-btn');
        self.DOM.closeBtn = document.querySelector('.btn--close');
        self.DOM.menuItems = self.DOM.elt.querySelectorAll('.menu__item, .c-social-menu--item');
        self.DOM.mainHeader = document.querySelector('.main-header');
        self.tl = new TimelineMax({
          paused: true,
          onReverseComplete: () => {
            self.DOM.elt.classList.remove('is-open');
            self.DOM.openBtn.classList.remove('is-active');
          },
        });
        self.isMenuOpen = false;
        self.initEvents();
        self.setScene();
      }
    }

    initEvents() {
      const self = this;
      self.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isMenuOpen) {
          self.toogle('close');
        } else {
          self.toogle('open');
        }
      });

      if (winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }
    }

    toogle(action) {
      this.isMenuOpen = action === 'open';

      if (this.isMenuOpen) {
        this.DOM.elt.classList.add('is-open');
        this.DOM.openBtn.classList.add('is-active');
        this.tl.play();
      } else {
        this.tl.reverse().timeScale(2);
      }
    }

    setScene() {
      this.tl.staggerFrom(this.DOM.menuItems, 0.2, { y: '15px', alpha: 0, ease: Circ.easeIn }, 0.1);
    }

    onScroll(e) {
      const windowScrollY = window.scrollY;
      //200
      if (windowScrollY > 50) {
        this.DOM.mainHeader.classList.add('is-sticky');
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.mainHeader.classList.remove('is-sticky');
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class SideNav {
    constructor() {
      if (document.querySelector('.c-sidebar')) {
        const self = this;
        self.DOM = { elt: document.querySelector('.c-sidebar') };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.elt.querySelector('.btn-toggle');
        self.DOM.menuItems = self.DOM.elt.querySelectorAll('nav + ul li.menu__item');
        if (typeof self.settings !== 'undefined' && 'pushedElements' in self.settings) {
          self.DOM.pushedElements = self.settings.pushedElements;
        }
        self.tl = new TimelineMax({
          paused: true,
          onReverseComplete: () => {
            self.DOM.elt.classList.remove('is-open');
            self.DOM.openBtn.classList.remove('is-active');
            if (self.DOM.pushedElements !== 'undefined') {
              self.DOM.pushedElements.forEach((elt) => {
                const pushedElt = document.querySelector(elt);
                if (pushedElt) {
                  pushedElt.classList.remove('is-pushed');
                }
              });
            }
            self.DOM.elt.dispatchEvent(self.event);
          },
          onComplete: () => {
            self.DOM.elt.dispatchEvent(self.event);
          },
        });
        self.isMenuOpen = false;
        self.initEvents();
        self.setScene();
      }
    }
    initEvents() {
      this.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isMenuOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });

      this.event = new Event('toggle');
    }
    toggle(action, _self) {
      const self = _self || this;
      self.isMenuOpen = action === 'open';

      if (self.isMenuOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
        self.tl.play();
        if (self.DOM.pushedElements !== 'undefined') {
          self.DOM.pushedElements.forEach((elt) => {
            const pushedElt = document.querySelector(elt);
            if (pushedElt) {
              pushedElt.classList.add('is-pushed');
            }
          });
        }
      } else {
        self.tl.reverse().timeScale(2);
      }
    }
    setScene() {
      this.tl.staggerFrom(this.DOM.menuItems, 0.2, { y: '15px', alpha: 0, ease: Circ.easeIn }, 0.1);
    }
  }

  class MasonryGrid {
    constructor(elt) {
      this.DOM = { elt };
      this.init();
    }

    init() {
      const msnry = new Masonry(this.DOM.elt, {
        columnWidth: '.js-grid-sizer',
        itemSelector: '.js-masonry__item',
        percentPosition: true,
        stagger: 60,
      });
      this.loader = new ImagesLoaded(this.DOM.elt).on('progress', (instance, image) => {
        if (image.isLoaded) {
          msnry.layout();
        }
      });
    }
  }

  class VimeoController {
    constructor(elt) {
      this.DOM = { elt };
      console.log('Vimeo::ctor');
      if (this.DOM.elt.querySelector('.video-overlay')) {
        this.DOM.playBtn = this.DOM.elt.querySelector('.video-overlay');
      }
      this.DOM.iframe = this.DOM.elt.querySelector('iframe');
      this.player = new Player(this.DOM.iframe);
      this.init();
    }
    init() {
      if (this.DOM.playBtn) {
        this.DOM.playBtn.addEventListener('click', () => {
          this.player.play();
          this.DOM.playBtn.classList.add('inactive');
        });
      }
    }

    pause() {
      if (this.player) {
        this.player.pause().then(() => {
          console.log('Vimeo::pause', this.player);
        });
      }
    }
  }

  class ClientsGrid {
    constructor(elt) {
      this.DOM = { elt };
      this.init();
    }

    init() {
      const iso = new Isotope(this.DOM.elt, {
        itemSelector: '.js-isotope-item',
        percentPosition: true,
        resizable: false, // disable normal resizing
        gutter: 10,
      });
      this.loader = new ImagesLoaded(this.DOM.elt).on('progress', (instance, image) => {
        if (image.isLoaded) {
          iso.layout();
        }
      });
      if (document.querySelector('.js-company-filter')) {
        this.filters = {};
        const checkboxes = document.querySelectorAll('.js-company-filter input');
        const companyFilterTxt = document.querySelector('.js-company-filter-text');
        const noResult = document.querySelector('.js-no-result');
        let filterValue = '';
        const self = this;
        checkboxes.forEach((cbx) => {
          cbx.addEventListener('change', (e) => {
            self.manageSelection(e.currentTarget);
            const comboFilter = ClientsGrid.getComboFilter(self.filters);
            iso.arrange({ filter: comboFilter });

            // const inclusives = [];
            // checkboxes.forEach((elt) => {
            //   if (elt.checked) {
            //     inclusives.push(elt.value);
            //   }
            // });
            // console.log(inclusives, e.currentTarget.checked, e.currentTarget.value);
            // filterValue = inclusives.length ? inclusives.join(', ') : '*';
            // if (companyFilterTxt) {
            //   companyFilterTxt.innerHTML = (filterValue !== '*' && filterValue !== '') ? `<span class="orange">Your current selection:</span> ${filterValue}` : '<span class="orange">Your current selection:</span> all';
            // }
            // iso.arrange({ filter: filterValue });
          });
        });
        iso.on('arrangeComplete', (filteredItems) => {
          if (filteredItems.length === 0) {
            noResult.classList.remove('hidden');
          } else {
            noResult.classList.add('hidden');
          }
        });
      }

      if (QUOLUX.sideNav.DOM.elt) {
        QUOLUX.sideNav.DOM.elt.addEventListener('toggle', () => {
          TweenMax.delayedCall(0.6, () => {
            iso.layout();
          });
        });
      }
    }

    static getComboFilter(filters) {
      let i = 0;
      let comboFilters = [];
      const message = [];
      const keys = Object.keys(filters);
      const values = Object.values(filters);
      for (let f = 0; f < keys.length; f += 1) {
        if (Object.prototype.hasOwnProperty.call(values, f)) {
          message.push(values[f].join(' '));
          const filterGroup = values[f];
          if (!filterGroup.length) {
            continue;
          }
          if (i === 0) {
            // copy to new array
            comboFilters = filterGroup.slice(0);
          } else {
            const filterSelectors = [];
            // copy to fresh array
            const groupCombo = comboFilters.slice(0);
            // merge filter Groups
            for (let k = 0, len3 = filterGroup.length; k < len3; k += 1) {
              for (let j = 0, len2 = groupCombo.length; j < len2; j += 1) {
                filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
              }
            }
            // apply filter selectors to combo filters for next group
            comboFilters = filterSelectors;
          }
          i += 1;
        }
      }
      const comboFilter = comboFilters.join(', ');
      return comboFilter;
    }

    manageSelection(checkbox) {
      const cbx = checkbox;
      const groupElt = cbx.parentElement.parentElement;
      const group = groupElt.getAttribute('data-group');
      if (typeof group !== 'undefined') {
        let filterGroup = this.filters[group];
        const checkedTotal = groupElt.querySelectorAll('input[type=checkbox]:checked').length;
        if (!filterGroup) {
          filterGroup = [];
          this.filters[group] = [];
          // console.log('creat a new array');
        }
        const isAll = checkbox.classList.contains('all');
        if (isAll) {
          delete this.filters[group];
          console.log('deleted group');
          if (!cbx.checked) {
            cbx.checked = true;
            // console.log('reset filter group if the all box was checked');
          }
        }
        const idx = filterGroup.indexOf(cbx.value);
        if (cbx.checked) {
          const selector = isAll ? 'input' : 'input.all';
          groupElt.querySelectorAll(selector).forEach((elt) => {
            if (elt !== cbx) {
              elt.checked = false;
              // console.log('Unchecked', elt.value);
            }
          });
          if (!isAll && idx === -1) {
            // add filter to group
            this.filters[group].push(cbx.value);
            // console.log('add', cbx.value);
          }
        } else if (!isAll) {
          // remove filter from group
          this.filters[group].splice(idx, 1);
          // if unchecked the last box, check the all
          if (checkedTotal === 0) {
            groupElt.querySelector('input.all').checked = true;
            // console.log('check all');
          }
        }
        // console.log(idx, group, filterGroup, 'all selected?', isAll);
      } else {
        console.error('missing data-group on parent element');
      }
    }
  }

  class Quiz {
    constructor() {
      const self = this;
      self.qualities = [
        { name: 'visionary', group: 'resonant' },
        { name: 'coaching', group: 'resonant' },
        { name: 'affiliative', group: 'resonant' },
        { name: 'democratic', group: 'resonant' },
        { name: 'pacesetting', group: 'dissonant' },
        { name: 'commanding', group: 'dissonant' }];
      self.data = {
        questions: [
          {
            step: 1,
            next: 2,
            prev: null,
            question: 'Can you list your key target markets in order of priority and profitability?',
            subQuestion: '',
            canSkip: false,
            answers: [
              {
                id: 'answer-1',
                text: 'Yes',
                quality: '',
              },
              {
                id: 'answer-2',
                text: 'No',
                quality: '',
              },
              {
                id: 'answer-3',
                text: 'I think so but the relevant senior managers do not know',
                quality: '',
              },
            ],
          },
          {
            step: 2,
            next: 3,
            prev: 1,
            question: 'On a typical day, who do you think you spend most time with in your company/team?',
            subQuestion: '',
            canSkip: false,
            answers: [
              {
                id: 'answer-1',
                text: 'The top 20% performers – the people who are highly conscientious, hardworking, and strongly positive towards the company.',
                quality: '',
              },
              {
                id: 'answer-2',
                text: 'The mid 60% performers – the main-stays of the company/team, who come in, do their work then leave and are generally positive towards the company.',
                quality: '',
              },
              {
                id: 'answer-3',
                text: 'The bottom 20% performers – the negative minority who never believe any company communication nor give credence to any new initiative. ',
                quality: '',
              },
            ],
          },
          {
            step: 3,
            next: 4,
            prev: 2,
            question: 'Your biggest customer has unexpectedly put your contract up for review with a month\'s notice.',
            subQuestion: 'Do you...',
            canSkip: false,
            answers: [
              {
                id: 'answer-1',
                text: 'Give employees a rallying speech reminding them of their roles in achieving the company\'s goals and producing exceptional results.',
                quality: 'visionary',
                group: 'resonant',
              },
              {
                id: 'answer-2',
                text: 'Ask the lead account manager to suggest how the problem might be approached; it’s an opportunity to demonstrate their personal strengths.',
                quality: 'coaching',
                group: 'resonant',
              },
              {
                id: 'answer-3',
                text: 'Hold a social night out – everyone\'s getting very stressed, which won\'t help the situation. ',
                quality: 'affiliative',
                group: 'resonant',
              },
              {
                id: 'answer-4',
                text: 'Bring together representatives from throughout the company and hold a workshop to get everyone\'s ideas of solutions.',
                quality: 'democratic',
                group: 'resonant',
              },
              {
                id: 'answer-5',
                text: 'Set some challenging performance goals for the team, clear your diary, and roll up your sleeves.',
                quality: 'pacesetting',
                group: 'dissonant',
              },
              {
                id: 'answer-6',
                text: 'Discover what\'s gone wrong, and tell the team exactly what they need to do to rectify the issues – quickly.',
                quality: 'commanding',
                group: 'dissonant',
              },
            ],
          },
          {
            step: 4,
            next: 5,
            prev: 3,
            question: 'You hold regular staff meetings where no one says anything, but you overhear grumbles in the staff cafeteria.',
            subQuestion: 'Do you...',
            canSkip: false,
            answers: [
              {
                id: 'answer-1',
                text: 'Raise it at the next staff meeting - making it clear you expect the same loyalty and drive from everyone that you give yourself. If they\'ve got anything to say now\'s their chance',
                quality: 'pacesetting',
                group: 'dissonant',
              },
              {
                id: 'answer-2',
                text: 'Ignore it - this is just banter, what really matters is performance. After all, the purpose of the staff meeting is to highlight departmental performance against KPIs',
                quality: 'commanding',
                group: 'dissonant',
              },
              {
                id: 'answer-3',
                text: 'Arrange a team-building away-day to get everyone excited about your vision and the role each person plays; you need to re-ignite the spark and togetherness',
                quality: 'visionary',
                group: 'resonant',
              },
              {
                id: 'answer-4',
                text: 'Conduct an anonymous survey of all staff; you need to find out what everyone really thinks, before discussing actions with your team leaders',
                quality: 'democratic',
                group: 'resonant',
              },
              {
                id: 'answer-5',
                text: 'Discretely take aside the person whom you overheard grumbling for a quiet chat; there could be any number of reasons why they are unhappy',
                quality: 'affiliative',
                group: 'resonant',
              },
              {
                id: 'answer-6',
                text: 'Look to your senior management team; are they all equipped to get the best out of their staff? In your next one-to-ones, ask open questions about the level of engagement within their teams',
                quality: 'coaching',
                group: 'resonant',
              },
            ],
          },
          {
            step: 5,
            next: null,
            prev: 4,
            question: 'After several years at your company you\'re now the managing director. The family-owner is still quite vocal in the boardroom, but he no longer has an executive role.',
            subQuestion: 'Do you...',
            canSkip: false,
            answers: [
              {
                id: 'answer-1',
                text: 'Keep focused; work hard, drive your team, achieve outstanding results – you’re clear about your role and that’s all that matters',
                quality: 'pacesetting',
                group: 'dissonant',
              },
              {
                id: 'answer-2',
                text: 'Feel that your authority is being undermined, which is unacceptable. Make it clear you’re in charge, and ask the family-owner not to interfere',
                quality: 'commanding',
                group: 'dissonant',
              },
              {
                id: 'answer-3',
                text: 'Feel sympathetic - it’s natural he should still care; you take him for a beer and tell him you still appreciate his insight \'off the record\'',
                quality: 'affiliative',
                group: 'resonant',
              },
              {
                id: 'answer-4',
                text: 'Begin the next board meeting by creating a set of \'ground rules\' for debating and listening to each other. Everyone contributes to the rules and everyone agrees to abide by them',
                quality: 'democratic',
                group: 'resonant',
              },
              {
                id: 'answer-5',
                text: 'Arrange a one-to-one with the family-owner, thank him for his continued passion, share your pride in the company\'s past achievements and your vision for its future success',
                quality: 'visionary',
                group: 'resonant',
              },
              {
                id: 'answer-6',
                text: 'Ask the family-owner where his aspirations lie now that he has handed control to the executive team; help him connect his personal goals to those of the business',
                quality: 'coaching',
                group: 'resonant',
              },
            ],
          },
        ],
      };
      self.currentSlide = 0;
      self.DOM = {
        elt: document.querySelector('.c-quiz'),
      };
      self.DOM.questionsElt = self.DOM.elt.querySelector('.c-quiz__questions');
      self.DOM.results = self.DOM.elt.querySelectorAll('.c-quiz__results');
      self.DOM.resultsOpts = self.DOM.elt.querySelectorAll('.c-quiz__result-opt');
      self.DOM.submitBtn = self.DOM.elt.querySelector('#quiz__submit');
      self.DOM.nextBtn = self.DOM.elt.querySelector('.btn.next');
      self.DOM.previousBtn = self.DOM.elt.querySelector('.btn.prev');
      self.DOM.pagination = self.DOM.elt.querySelector('.c-quiz__pagination');
      self.DOM.stepBarDots = self.DOM.elt.querySelectorAll('.c-steps-indicator-bar__dot');
      self.DOM.stepBars = self.DOM.elt.querySelectorAll('.c-steps-indicator-bar__bar');

      if (self.DOM.results.length) {
        // result page
        self.calculateResultFromUrl();
      } else {
        // start quiz
        self.init();
      }
    }

    calculateResultFromUrl() {
      const self = this;
      const params = new URLSearchParams(window.location.search);
      const answers = [];
      params.forEach((value, key) => {
        const j = parseInt(value.split('answer-')[1], 0);
        const i = parseInt(key.split('question-')[1], 0);
        answers.push({
          id: i,
          choice: value,
          quality: (i >= 2) ? self.data.questions[i].answers[j - 1].quality : 'NA',
          group: (i >= 2) ? self.data.questions[i].answers[j - 1].group : 'NA',
        });
      });

      console.log('init result', answers);
      if (answers.length > 0) {
        self.processResult(answers);
      }
    }

    init() {
      const self = this;
      self.create();
      self.DOM.slides = self.DOM.elt.querySelectorAll('.c-quiz__slide');
      self.DOM.submitBtn.addEventListener('click', self.calculateResult.bind(self));
      self.DOM.previousBtn.addEventListener('click', self.previous.bind(self));
      self.DOM.nextBtn.addEventListener('click', self.next.bind(self));
      self.showSlide(0);
    }

    create() {
      const output = [];
      this.data.questions.forEach((currentQuestion, questionNumber) => {
        const answers = [];
        currentQuestion.answers.forEach((answer, index) => {
          answers.push(`<div class="form-control  radio span-4 span-lg-4 span-md-4 span-sm-12 span-xs-12">
          <label name="">
        <input type="radio" name="question-${questionNumber}"
        value="${answer.id}" data-id="${index}">
        <span>${answer.text}</span>
      </label></div>`);
        });

        output.push(`<div class="c-quiz__slide"><fieldset class="c-quiz__question" id="question-${questionNumber}"><div class="question large orange"> ${currentQuestion.question} </div>
          <div class="answers eq-height"> ${answers.join('')} </div><div class="field-validation-error red span-12 hidden">Please select an option</div></fieldset></div>`);
      });
      this.DOM.questionsElt.innerHTML = output.join('');
    }

    calculateResult() {
      const self = this;
      const answersElt = this.DOM.elt.querySelectorAll('.answers');
      const answers = [];

      if (self.validate(self.currentSlide)) {
        self.data.questions.forEach((currentQuestion, questionNumber) => {
          const answerElt = answersElt[questionNumber];
          const selector = `input[name=question-${questionNumber}]:checked`;
          const userAnswer = (answerElt.querySelector(selector) || {}).value;
          if (userAnswer) {
            const idx = parseInt(userAnswer.split('answer-')[1], 0);
            answers.push({ id: questionNumber, choice: userAnswer, quality: (questionNumber >= 2) ? self.qualities[idx - 1] : 'NA' });
          } else {
            answers.push({ id: questionNumber, choice: undefined });
          }
        });
        self.hideError(self.currentSlide);
        self.processResult(answers);
      } else {
        self.showError(self.currentSlide);
      }
    }

    processResult(answers) {
      const self = this;
      let currentResult;
      const chosenQualities = [];
      console.log('Usr Submissions', answers);
      self.DOM.resultsOpts.forEach((elt) => {
        elt.classList.remove('is-active');
      });
      answers.forEach((answer, index) => {
        if (index <= 1) {
          if (typeof answer.choice !== 'undefined') {
            currentResult = document.querySelector(`#result-${index + 1} [data-id='${answer.choice}']`);
            currentResult.classList.add('is-active');
          } else {
            console.log('not filled...');
          }
        }
        if (typeof answer.choice !== 'undefined' && answer.quality !== 'NA') {
          chosenQualities.push({
            quality: answer.quality,
            group: answer.group,
          });
        }
      });
      // common
      currentResult = document.querySelector('#result-3');
      currentResult.classList.add('is-active');
      self.DOM.results.forEach((elt) => {
        elt.classList.add('is-active');
      });

      const duplicateQuality = Quiz.findDuplicatesByPropName(chosenQualities, 'quality');
      const duplicateGroupByQuality = Quiz.findDuplicatesByPropName(chosenQualities, 'group');

      currentResult = document.querySelector('#result-4');
      currentResult.classList.add('is-active');
      if (duplicateQuality.length > 0) {
        currentResult = document.querySelector(`#result-4 [data-id='${duplicateQuality[0].quality}']`);
        currentResult.classList.add('is-active');
      } else if (duplicateGroupByQuality.length > 0) {
        console.log('no matching');
        // chosenQualities.forEach((quality) => {
        //   if (quality === 'visionary' || quality === 'coaching' || quality === 'affiliative' || quality === 'democratic') {
        //     group = 'resonant';
        //   } else if (quality === 'pacesetting' || quality === 'commanding') {
        //     group = 'dissonant';
        //   }
        // });
        currentResult = document.querySelector(`#result-4 [data-id='${duplicateGroupByQuality[0].group}']`);
        currentResult.classList.add('is-active');
        currentResult.querySelector('p').innerHTML = `${currentResult.querySelector('p').innerHTML} <strong class="orange">${duplicateGroupByQuality.map(e => e.quality).join(' and ')}</strong>`;
      }
      console.log(chosenQualities, duplicateQuality, duplicateGroupByQuality);
    }

    showSlide(index) {
      const self = this;
      self.DOM.slides[self.currentSlide].classList.remove('is-active');
      self.DOM.slides[index].classList.add('is-active');
      self.currentSlide = index;
      if (self.currentSlide === 0) {
        self.DOM.previousBtn.style.display = 'none';
      } else {
        self.DOM.previousBtn.style.display = 'inline-block';
      }
      if (self.currentSlide === self.DOM.slides.length - 1) {
        self.DOM.nextBtn.style.display = 'none';
        self.DOM.submitBtn.style.display = 'inline-block';
      } else {
        self.DOM.nextBtn.style.display = 'inline-block';
        self.DOM.submitBtn.style.display = 'none';
      }
    }

    next() {
      if (this.validate(this.currentSlide)) {
        const slideNum = this.currentSlide + 1;
        this.showSlide(slideNum);
        this.updatePaging(slideNum + 1);
        this.updateProgress(slideNum);
        this.hideError(this.currentSlide);
      } else {
        this.showError(this.currentSlide);
      }
    }

    previous() {
      const slideNum = this.currentSlide - 1;
      this.showSlide(slideNum);
      this.updatePaging(slideNum + 1);
      this.updateProgress(slideNum);
    }

    updatePaging(index) {
      this.DOM.pagination.innerHTML = `Question ${index}`;
    }

    updateProgress(index) {
      const self = this;
      self.DOM.stepBarDots.forEach((elt, idx) => {
        if (index >= idx) {
          elt.classList.add('c-steps-indicator-bar__dot--done');
        } else {
          elt.classList.remove('c-steps-indicator-bar__dot--done');
        }
      });

      self.DOM.stepBars.forEach((elt, idx) => {
        if (index >= idx) {
          elt.classList.add('c-steps-indicator-bar__bar--done');
        } else {
          elt.classList.remove('c-steps-indicator-bar__bar--done');
        }
      });
    }

    validate(index) {
      const selector = document.querySelector(`#question-${index} input:checked`);
      return (selector) ? true : false;
    }

    showError(index) {
      const selector = document.querySelector(`#question-${index} .field-validation-error`);
      this.DOM.elt.querySelectorAll('.c-quiz__question .field-validation-error').forEach((elt) => {
        elt.classList.add('hidden');
      });
      if (selector) {
        selector.classList.remove('hidden');
      }
    }

    hideError(index) {
      const selector = document.querySelector(`#question-${index} .field-validation-error`);
      this.DOM.elt.querySelectorAll('.c-quiz__question .field-validation-error').forEach((elt) => {
        elt.classList.add('hidden');
      });
      if (selector) {
        selector.classList.add('hidden');
      }
    }

    static findDuplicates(arr) {
      return [...new Set(arr.filter(v => arr.indexOf(v) !== arr.lastIndexOf(v)))];
    }

    static findDuplicatesByPropName(arr, propName) {
      const lookup = arr.reduce((a, e) => {
        a[e[propName]] = ++a[e[propName]] || 0;
        return a;
      }, {});
      const filtered = arr.filter(e => lookup[e[propName]]);
      return filtered;
    }
  }

  class FlowChartItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-flow-card__title');
      this.DOM.content = this.DOM.elt.querySelector('.c-flow__wrapper');
      this.isOpen = this.DOM.elt.classList.contains('is-selected');
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        TweenMax.to(this.DOM.content, 0.2, { height: 'auto' });
        if (this.DOM.btn) {
          scrollTo(this.DOM.btn, 0.6);
        }
        this.DOM.elt.classList.add('is-selected');
      } else {
        TweenMax.to(this.DOM.content, 0.2, { height: 0 });
        this.DOM.elt.classList.remove('is-selected');
      }
    }
  }

  class FlowChart {
    constructor(elt) {
      this.DOM = { elt };
      this.menuItems = [];
      Array.from(this.DOM.elt.querySelectorAll('.c-flow-chart__item')).forEach(item => this.menuItems.push(new FlowChartItem(item)));
      this.init();
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    } 

    initEvents() {
      for (const [pos, item] of this.menuItems.entries()) {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      }
    }

    showContent(pos) {
      console.log('POS', pos);
      if (this.current !== pos && this.menuItems[this.current].isOpen) {
        this.menuItems[this.current].hide();
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }

  function initEvents() {
    if (document.querySelector('.btn-up')) {
      document.querySelector('.btn-up').addEventListener('click', () => {
        scrollTo(document.querySelector('body'));
      });
    }

    if (window.location.hash) {
      TweenMax.delayedCall(1, scrollToId, [window.location.hash]);
    }

    if (document.querySelector('.validation-summary-errors')) {
      scrollTo(document.querySelector('.validation-summary-errors'));
    }

    if (document.querySelector('.validation-summary-success')) {
      scrollTo(document.querySelector('.validation-summary-success'));
    }
  }

  function init() {
    QUOLUX.mainNav = new MainNav();
    QUOLUX.sideNav = new SideNav();
    QUOLUX.scrollPlugin = ScrollToPlugin;
    QUOLUX.masonrys = [];
    let idx = 1;
    document.querySelectorAll('.js-masonry').forEach((elt) => {
      const msnry = new MasonryGrid(elt);
      QUOLUX.masonrys.push = { id: `msnry${idx}`, msnry };
      idx += 1;
    });
    if (document.querySelector('.js-carousel-wrapper')) {
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        QUOLUX.carousels = new Carousels(element);
      });
    }

    if (document.querySelector('.video-wrapper iframe')) {
      QUOLUX.vimeos = [];
      document.querySelectorAll('.video-wrapper').forEach((element) => {
        QUOLUX.vimeos.push(new VimeoController(element));
      });
    }

    if (document.querySelector('.c-accordion-menu')) {
      QUOLUX.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu').forEach((element) => {
        QUOLUX.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelector('.c-sidebar') && QUOLUX.sideNav && !QUOLUX.Util.isMobile() && winSize.width > 1024) {
      TweenMax.delayedCall(1, QUOLUX.sideNav.toggle, ['open', QUOLUX.sideNav]);
    }
    if (document.querySelector('.js-grid')) {
      QUOLUX.clientsGrid = new ClientsGrid('.js-grid');
    }

    if (document.querySelector('.c-quiz')) {
      QUOLUX.quiz = new Quiz();
    }

    if (winSize.width <= SCREEN_SM_MAX && document.querySelector('.c-flow-chart')) {
      QUOLUX.flowChart = [];
      document.querySelectorAll('.c-flow-chart').forEach((element) => {
        QUOLUX.flowChart.push(new FlowChart(element));
      });
    }
    initEvents();
  }

  QUOLUX.Util = {
    isMobile: () => (typeof window.orientation !== 'undefined')
    || navigator.userAgent.indexOf('IEMobile') !== -1
    || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    || navigator.userAgent.match(/Android/i) !== null
    || navigator.userAgent.match(/webOS/i) !== null
    || navigator.userAgent.match(/iPhone/i) !== null
    || navigator.userAgent.match(/iPad/i) !== null
    || navigator.userAgent.match(/iPod/i) !== null
    || navigator.userAgent.match(/BlackBerry/i) !== null
    || navigator.userAgent.match(/Windows Phone/i) !== null,
    getRandomInt: (min, max) => Math.floor(Math.random() * ((max - min) + 1)) + min,
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  if (window.location.hash) {
    window.scrollTo(0, 0);
  }
})();
